import frFlag from "images/fr.png"
import enFlag from "images/en.png"
import esFlag from "images/es.png"

export const defaultBackgroundColor = "" //"#004346"
export const defaultTextColor = "" // "#fff"
export const defaultBrightBackgroundColor = "" // "#00434681"
export const currency = "€"

export enum SupportedLanguages {
  EN = "en",
  FR = "fr",
  ES = "es",
}

export const CountriesFlags: Record<SupportedLanguages, string> = {
  [SupportedLanguages.EN]: enFlag,
  [SupportedLanguages.FR]: frFlag,
  [SupportedLanguages.ES]: esFlag,
}

export const LANG_QUERY_PARAM = "lang"
